import { useTolgee } from '@tolgee/vue'

// Extend the global scope with $t
declare global {
  var $t: (key: string, params?: Record<string, any>) => string
}

export default defineNuxtPlugin((nuxtApp) => {
  const tolgeeRef = useTolgee()

  // Create a reactive function that always uses the latest t function
  const reactiveT = (key: string, params?: Record<string, any>) => {
    return tolgeeRef.value.t(key, params)
  }

  // Add $t to global scope
  globalThis.$t = reactiveT

  // Make it available in the Nuxt context
  nuxtApp.provide('t', reactiveT)
})
